import React, {
 useContext, useState, useEffect,
} from 'react';
import { BriefingContext } from '../../../../containers/campanhas/Briefing';
import Input from '../../InputGroup/Input';
import { ErrorMessage } from './style';


const BriefingStep5 = () => {
    const {
        urls,
	} = useContext(BriefingContext);

	const [hasTyped, setHasTyped] = useState(false);

	useEffect(() => {
		setHasTyped(false);
		let timeout = null;
		timeout = setTimeout(() => {
			setHasTyped(true);
		}, 500);
		return () => clearTimeout(timeout);
	}, [urls.url]);

    return (
	<>
		<div className="row" style={{ marginBottom: '20px' }}>
			<div className="col-12">
				<div style={{ minHeight: '73px' }}>
					<Input
						type="url"
						label="Insira abaixo a URL do site institucional da sua loja:"
						placeholder="www.exemplo.com.br"
						id="url"
						value={urls.url}
						onChange={e => urls.setUrl(e.target.value)}
						theme="light"
						padding="4px 0"
						fontSize="15px"
					/>
					{
						hasTyped
						&& !urls.isValidUrl
						&& <ErrorMessage>Url inválida</ErrorMessage>
					}
				</div>
			</div>
		</div>
	</>
    );
};

export default BriefingStep5;
